import PropTypes from 'prop-types';
import React from 'react'

import { TextLength, Icon } from '~/components'
import { TextEdit } from '~/services'


export default class extends React.Component {
    static propTypes = {
		user: PropTypes.object.isRequired,
		editing_fields: PropTypes.bool.isRequired,
		isSessionUser: PropTypes.bool.isRequired,
		updateField: PropTypes.func.isRequired,
	};

    updateField = (e) => {
		let val = e.target.value;
		this.props.updateField('boma_mini_bio', val)
	};

    render() {

		let { user, editing_fields, isSessionUser } = this.props,
			bioSet = !!user.mini_bio;

		if( !bioSet && !isSessionUser ) return null;

		return (

			<h6 id="mini-bio-field" className={"mtop0 mbot20 mbot10-xs" + (!bioSet ? ' text-dark-gray' : '')}>
				{ editing_fields
					? <TextLength defaultValue={user.mini_bio} 
								onChange={this.updateField} 
								placeholder="Write a little about yourself" 
								className="form-control" 
								maxLength="50" />
					: bioSet ? TextEdit.cutText(user.mini_bio, 200) : 'Write a little about yourself'
				}
			</h6>
			
		)
	}
}



// WEBPACK FOOTER //
// ./src/js/views/Profile/components/Header/components/MiniBio.jsx